import { useSearchParams } from 'react-router'
import { Tabs } from '@/ui'
import { InvitationsListTab } from './InvitationsListTab'
import { UpcomingWeddingsTab } from './UpcomingWeddingsTab'
import styles from './Invitations.module.css'

const TABS = [
  { key: 'list', label: '청첩장 목록' },
  { key: 'upcoming', label: '결혼 임박' },
]
const VALID_TABS = TABS.map((t) => t.key)

export function Invitations() {
  const [searchParams, setSearchParams] = useSearchParams()
  const rawTab = searchParams.get('tab')
  const tab = VALID_TABS.includes(rawTab ?? '') ? (rawTab as string) : 'list'

  const setTab = (key: string) => {
    const next = new URLSearchParams(searchParams)
    next.set('tab', key)
    // 다른 파라미터(status/within/uwPage 등) 보존
    setSearchParams(next, { replace: true })
  }

  return (
    <div className={styles.root}>
      <Tabs items={TABS} value={tab} onChange={setTab} />
      {tab === 'list' ? <InvitationsListTab /> : <UpcomingWeddingsTab />}
    </div>
  )
}
